// =============================================
// تنسيق التواريخ — ميلادي + هجري معاً
// =============================================

const gregFmt = new Intl.DateTimeFormat('ar-EG', {
  day: '2-digit', month: '2-digit', year: 'numeric',
});
const hijriFmt = new Intl.DateTimeFormat('ar-SA', {
  day: '2-digit', month: '2-digit', year: 'numeric',
});
const timeFmt = new Intl.DateTimeFormat('ar-EG', {
  hour: '2-digit', minute: '2-digit',
});
const gregShort = new Intl.DateTimeFormat('ar-EG', {
  day: 'numeric', month: 'short',
});
const hijriShort = new Intl.DateTimeFormat('ar-SA', {
  day: 'numeric', month: 'short',
});
const gregFull = new Intl.DateTimeFormat('ar-EG', {
  weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
});
const hijriFull = new Intl.DateTimeFormat('ar-SA', {
  day: 'numeric', month: 'long', year: 'numeric',
});

function toDate(d) {
  if (!d) return null;
  const date = d instanceof Date ? d : new Date(d);
  return isNaN(date) ? null : date;
}

// "DD/MM/YYYY · DD/MM/YYYY هـ"
export function fmtDateBoth(d) {
  const date = toDate(d);
  if (!date) return '—';
  return `${gregFmt.format(date)} · ${hijriFmt.format(date)} هـ`;
}

// "DD/MM/YYYY HH:MM · DD/MM/YYYY هـ"
export function fmtDateTimeBoth(d) {
  const date = toDate(d);
  if (!date) return '—';
  return `${gregFmt.format(date)} ${timeFmt.format(date)} · ${hijriFmt.format(date)} هـ`;
}

// "DD MMM · DD MMM هـ" — للأماكن الضيقة
export function fmtDateShort(d) {
  const date = toDate(d);
  if (!date) return '—';
  return `${gregShort.format(date)} · ${hijriShort.format(date)} هـ`;
}

// "Friday, 25 April 2026 · 7 شوال 1447 هـ" — للعناوين
export function fmtDateFull(d) {
  const date = toDate(d);
  if (!date) return '—';
  return `${gregFull.format(date)} · ${hijriFull.format(date)} هـ`;
}

// تنسيق ميلادي فقط (للحقول التي لا تتّسع)
export function fmtDate(d) {
  const date = toDate(d);
  return date ? gregFmt.format(date) : '—';
}

// "Xس Yد" — تحويل الدقائق الخام إلى ساعات ودقائق
export function fmtMinutes(mins) {
  const m = Number(mins) || 0;
  if (m < 60) return `${m}د`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  return r ? `${h}س ${r}د` : `${h}س`;
}
